import React from 'react';
import Modal from 'react-modal';
import { observer } from 'mobx-react';
import { Loader } from 'core/components';

function BaasicModalTemplate({ modalParams, children, ...other }) {
	return (
		<Modal
			className="ReactModal__Content"
			overlayClassName="ReactModal__Overlay"
			isOpen={modalParams.isOpen}
			shouldCloseOnOverlayClick={false}
			onRequestClose={modalParams.close}
			{...other}
		>
			<a className="ReactModal__close" onClick={modalParams.close} data-cy="modal-close-anchor">
				<i className="fa fa-times" data-cy="modal-close-anchor" onClick={() => modalParams.close(false)}></i>
			</a>
			{modalParams.loading ? <Loader /> : children}
		</Modal>
	);
}

export default observer(BaasicModalTemplate);



// WEBPACK FOOTER //
// ./src/themes/default/components/dialog/BaasicModalTemplate.jsx